import { Button, Col, Form, Input, Modal, notification, Row } from 'antd';
import React, { useCallback, useEffect } from 'react';

import { DefaultClass } from '../../models/DefaultClass';

interface IProps {
  selectedDefaultClass?: DefaultClass;
  submitting?: boolean;
  error: Error | null;
  onClose: () => void;
  onSubmit: (classification: DefaultClass) => void;
}

const DefaultClassModal: React.FC<IProps> = ({
  error,
  onClose,
  onSubmit,
  selectedDefaultClass,
  submitting,
}) => {
  const [form] = Form.useForm();

  const closeModal = useCallback(() => {
    form.resetFields();
    onClose();
  }, [form, onClose]);

  const submitModal = useCallback(
    (classification: DefaultClass) => {
      if (selectedDefaultClass) {
        classification.id = selectedDefaultClass.id;
      }
      onSubmit(classification);
    },
    [onSubmit, selectedDefaultClass]
  );

  useEffect(() => {
    if (selectedDefaultClass) {
      form.setFieldsValue(selectedDefaultClass);
    }
  }, [form, selectedDefaultClass]);

  useEffect(() => {
    if (error) {
      notification.error({
        description: error.message,
        message: error.name,
      });
    }
  }, [error]);

  return (
    <Modal
      centered
      visible
      footer={null}
      maskClosable={false}
      title={!selectedDefaultClass ? 'Add Default Class' : 'Update Default Class'}
      width={400}
      onCancel={closeModal}
    >
      <Form form={form} layout="vertical" onFinish={submitModal}>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              label="Default Class Name"
              name="name"
              rules={[{ message: 'Default class name is required!', required: true }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item>
              <Button className="modal-close-btn" onClick={closeModal}>
                Cancel
              </Button>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item>
              <Button
                className="modal-save-btn"
                htmlType="submit"
                loading={submitting}
                type="primary"
              >
                SAVE
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default DefaultClassModal;
